module.exports = __webpack_public_path__ + "img/intrusion-systemimg-5.5e3cdaf8.png";